<div class="row main transition5"
  [ngClass]="{'change-scrollbar-color-darkMode': settings.darkModeSetting, 'change-scrollbar-color': !settings.darkModeSetting}">
  <div class="animated fadeIn unset-p" [ngClass]="settings.darkModeSetting ? 'bg-dark' : 'bg-white'">
    <div class="relative padding5 full-width transition5 auto-height"
      [ngClass]="settings.darkModeSetting ? 'bg-dark' : 'bg-white'">
      <div class="row" [ngClass]="settings.darkModeSetting ? 'bg-dark' : 'bg-white'">
        <div class="padding5 b-radius control-bar"
          [ngClass]="settings.darkModeSetting ? 'bg-dark-secondary' : 'bg-light-blue'">
          <div class="col-5 flex unset-p flex align-centre animated fadeIn">
            <div class="relative">
              <input #inputEl class="form-control cursorPointer" style="width: 500px;" type="text"
                [(ngModel)]="keyValue" (keyup)="change($event)" (click)="openDropdown($event, op)"
                [ngClass]="[settings.darkModeSetting ? 'textWhite' : 'textBlack', 'font' + settings.textSizeSetting]" />
              <fa-icon [icon]="faChevronDown" class="absolute bg-none combo-input-icon padding5"
                style="pointer-events: none;"
                [ngClass]="[settings.darkModeSetting ? 'textWhite' : 'textBlack', 'font' + settings.textSizeSetting]"></fa-icon>
            </div>
            <p-overlayPanel #op>
              <ng-template pTemplate="content" class="full-width unset-p">
                <div class="combo-options-container b-radius p-unset overflow-auto full-width"
                  [ngClass]="[settings.darkModeSetting ? 'bg-dark textWhite' : 'bg-white textBlack', 'font' + settings.textSizeSetting]">
                  <div #optionEl *ngFor="let item of filteredLookupValues; let i = index"
                    class="combo-option poppins relative" (mousedown)="updateCombos(item, op)"
                    [ngClass]="item.selected ? 'bg-green textWhite' : settings.darkModeSetting ? 'bg-dark' : 'bg-white'">
                    <span class="absolute" style="top: 50%; transform: translate(10px, -50%);">
                      {{ item.lookUpValue.value }}
                    </span>
                  </div>
                  <span *ngIf="filteredLookupValues && filteredLookupValues.length === 0"
                    class="combo-option poppins flex justify-centre align-centre"
                    [ngClass]="[settings.darkModeSetting ? 'bg-dark textWhite' : 'bg-white textBlack', 'font' + settings.textSizeSetting]">
                    {{app.translations.GBL_lbl_NoResults}}
                  </span>
                </div>
              </ng-template>
            </p-overlayPanel>
          </div>
        </div>
      </div>
      <div class="animated fadeIn" style="margin-top: 5px;">
        <dx-gantt #ganttChart taskListWidth="500" scaleType="weeks" style="height: 85vh !important;" class="b-radius"
          [editing]="{ enabled: true }" (onTaskClick)="selectTask($event);" (onTaskUpdated)="onTaskUpdated($event)" 
          (onResourceAssigning)="onResourceAssigning($event)" (onResourceUnassigned)="onResourceUnassigned($event)">

          <dxo-tasks disabled="true" [dataSource]="ganttTasks" keyExpr="id" parentIdExpr="parent" titleExpr="title"
            progressExpr="progress" startExpr="start" endExpr="end" colorExpr="color" durationExpr="duration"
            resourceExpr="resourcename"></dxo-tasks>
          <dxo-dependencies [dataSource]="ganttDependencies"></dxo-dependencies>

          <dxi-column dataField="title" caption="Subject" [width]="300"></dxi-column>
          <dxi-column dataField="start" caption="Start Date" dataType="date" format="dd/MM/yyyy"></dxi-column>
          <dxi-column dataField="end" caption="End Date" dataType="date" format="dd/MM/yyyy"></dxi-column>
          <dxi-column dataField="progress" caption="Progress"></dxi-column>
          <dxi-column dataField="duration" caption="Duration"></dxi-column>
          
          <dxo-resources [dataSource]="ganttResources" keyExpr="resourcename" textExpr="resourcename">
          </dxo-resources>

          <dxo-resource-assignments [dataSource]="ganttAssignments" taskIdExpr="taskId" resourceIdExpr="resourcename">
          </dxo-resource-assignments>

          <dxo-toolbar>
            <dxi-item name="zoomIn"></dxi-item>
            <dxi-item name="zoomOut"></dxi-item>
          </dxo-toolbar>

          <dxo-editing [enabled]="true" [allowDependencyAdding]="false" [allowDependencyDeleting]="false"
            [allowResourceAdding]="true" [allowResourceDeleting]="true" [allowTaskAdding]="false"
            [allowTaskDeleting]="false" [allowTaskResourceUpdating]="true" [allowTaskUpdating]="true">
          </dxo-editing>
        </dx-gantt>
      </div>
    </div>
  </div>
</div>